import React from 'react';

const PlusIconSVG = () => (
    <svg viewBox="0 0 24 24">
        <path d="M12 5V19" stroke="#F76566 " strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5 12H19" stroke="#F76566 " strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default PlusIconSVG;